import {
  DropdownInput,
  FilterPanel,
  StorageKeys,
  TextInput,
} from "@validereinc/common-components";
import { WorkflowCategoriesAdapter } from "@validereinc/domain";
import { Workflows } from "@validereinc/domain-controllers";
import React from "react";

const { WorkflowTemplateStatusOptions } = Workflows.view;

export const WorkflowTemplatesFilterPanel = ({
  filterConfigStorageKey,
  showCategoryFilter = true,
}: {
  showCategoryFilter?: boolean;
} & Pick<StorageKeys, "filterConfigStorageKey">) => {
  return (
    <FilterPanel
      storageKey={filterConfigStorageKey}
      defaultActiveKeys={["Filters"]}
      defaultValue={{ status: ["active"] }}
      filters={[
        {
          component: (
            <TextInput
              name="name"
              key="workflow-templates-name-filter"
              placeholder="Search Templates..."
              type="search"
              isInline
              isFluid={false}
            />
          ),
        },
        {
          component: (
            <DropdownInput
              key="status"
              name="status"
              placeholder="Select a Status"
              options={WorkflowTemplateStatusOptions}
              labelKey="label"
              valueKey="value"
              isInline
              isSearchable
              isMulti
              isFluid={false}
            />
          ),
        },
        ...(showCategoryFilter
          ? [
              {
                component: (
                  <DropdownInput
                    key="category_id"
                    name="category_id"
                    onFetchData={async (payload) => {
                      let { data } = await WorkflowCategoriesAdapter.getList({
                        ...payload,
                        filters: {
                          ...(payload.searchTerm
                            ? {
                                name: payload.searchTerm,
                              }
                            : {}),
                        },
                      });

                      // REVIEW: not a fan of the fact that we need to do this. A refactor of DropdownInput is needed.
                      if (Array.isArray(payload.value)) {
                        data = data.filter((d) => payload.value.includes(d.id));
                      }

                      return data;
                    }}
                    labelKey="name"
                    valueKey="id"
                    placeholder="Select Category"
                    isInline
                    isMulti
                    isFluid={false}
                  />
                ),
              },
            ]
          : []),
      ]}
    />
  );
};
